import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';

import SavedViewUpdatesAsideAggRootQueryNode, {
	type SavedViewUpdatesAsideAggRootQuery,
} from '../SavedViewUpdates/agg/__generated__/SavedViewUpdatesAsideAggRootQuery.graphql';

export const savedViewUpdatesAsideAggResource =
	createRelayResource<SavedViewUpdatesAsideAggRootQuery>({
		getQuery: (routerContext, resourceContext) => {
			const context = resourceContext as ResourceContext;

			return {
				query: SavedViewUpdatesAsideAggRootQueryNode,
				variables: {
					containerId: context.collabContext?.contextId || '',
					directoryId: routerContext.match.params.uuid || '',
				},
				options: {
					fetchPolicy: 'store-and-network',
				},
				environment: getAggRelayEnvironment(),
			};
		},
	});
